module.exports = __webpack_public_path__ + "static/media/404-error-with-a-tired-person-pana-red-online.ddede90b.svg";